// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Premješteno: ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accCommandKey: () => 'Naredba',
  accControlKey: () => 'Zatvori',
  accPositionAfter: () => 'nakon',
  accPositionBefore: () => 'prije',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Pritisnite i držite ' +
    p['keyPressed'] +
    ' i tipku Shift, a zatim promijenite redoslijed pomoću tipki sa strelicama.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Unesi potpun datum u ovom formatu: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Unesi mjesec i godinu u ovom formatu: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Grupa',
  chart_labelSeries: () => 'Serija',
  chart_labelValue: () => 'Vrijednost',
  checkboxSet_requiredMessageDetail: () => 'Obavezno',
  checkbox_requiredMessageDetail: () => 'Obavezno',
  close: () => 'Zatvori',
  collection_noData: () => 'Nema podataka za prikaz.',
  collection_selectAllRows: () => 'Izaberi sve redove',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Izaberi red ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Ne može se poredati',
  collection_sortEnabled: () => 'Može se poredati',
  confirmation: () => 'Potvrda',
  datePicker_currentDate: () => 'Trenutni datum',
  datePicker_goToToday: () => 'Idi na danas',
  datePicker_label: () => 'Birač datuma',
  datePicker_month: () => 'Mjesec',
  datePicker_months: () => 'Mjeseci',
  datePicker_next: () => 'Sljedeće',
  datePicker_nextDecade: () => 'Sljedeća dekada',
  datePicker_nextMonth: () => 'Sljedeći mjesec',
  datePicker_prev: () => 'Prethodno',
  datePicker_prevDecade: () => 'Prethodna dekada',
  datePicker_prevMonth: () => 'Prethodni mjesec',
  datePicker_restricted: () => 'Ograničeno',
  datePicker_selected: () => 'Izabrano',
  datePicker_today: () => 'Danas',
  datePicker_weekNum: (p: { NUM: string }) => p['NUM'] + '. sedmica',
  datePicker_weekNumColLabel: () => 'Broj sedmice',
  datePicker_year: () => 'Godina',
  datePicker_years: () => 'Godine',
  error: () => 'Greška',
  expandableList_expandCollapseInstructionText: () =>
    'Koristi tipke sa strelicama za proširivanje i sužavanje',
  expandableList_groupCollapse: () => 'Sažeto',
  expandableList_groupExpand: () => 'Prošireno',
  filePicker_addFiles: () => 'Dodaj datoteke',
  filePicker_dropzonePrimaryText: () => 'Povuci i ispusti',
  filePicker_dropzoneSecondaryText: () => 'Izaberi datoteku ili ispusti neku ovdje',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Izaberi ili ispusti datoteke ovdje',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Ne možete učitati datoteke vrste ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Učitaj jednu po jednu datoteku',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Ne možete učitati datoteke vrste ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'nepoznato',
  formControl_clear: () => 'Očisti',
  formControl_day: () => 'Dan',
  formControl_helpAvailable: () => 'Dostupna je pomoć',
  formControl_hide: () => 'Sakrij',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Dostigli ste ograničenje od ' +
    ((
      {
        one: new Intl.NumberFormat('bs').format(p['CHARACTER_LIMIT']) + ' znaka',
        few: new Intl.NumberFormat('bs').format(p['CHARACTER_LIMIT']) + ' znaka'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('bs').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('bs').format(p['CHARACTER_LIMIT']) + ' znakova') +
    '.',
  formControl_loading: () => 'Učitavanje',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Možete unijeti do ovoliko znakova: ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Preostalo znakova: ' + p['CHARACTER_COUNT'] + '.',
  formControl_month: () => 'Mjesec',
  formControl_readOnly: () => 'Samo za čitanje',
  formControl_requiredMessageDetail: () => 'Unesi vrijednost.',
  formControl_show: () => 'Prikaži',
  formControl_year: () => 'Godina',
  gantt_labelDate: () => 'Datum',
  gantt_labelEnd: () => 'Kraj',
  gantt_labelLabel: () => 'Oznaka',
  gantt_labelRow: () => 'Red',
  gantt_labelStart: () => 'Početak',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nije pronađen nijedan podudaran odjeljak.',
  indexer_keyboardInstructionText: () => 'Pritisni Enter za izbor vrijednosti.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Između ' + p['FROM_SECTION'] + ' i ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Dvaput dodirnuti i držati. Čekati na zvuk i onda prevući da bi se preuredilo.',
  info: () => 'Informacije',
  inputDateMask_date_cleared: () => 'Datum je izbrisan',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Prazno',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'gggg',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Unesi datum koji nije kasniji od ' + p['max'] + '.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Unesi datum koji nije raniji od ' + p['min'] + '.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Unesi dostupan datum.',
  inputDatePicker_instruction: () => 'Pritisnite Tab da biste pristupili kalendaru.',
  inputDatePicker_selectDate: () => 'Izaberi datum',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Unesi mjesec i godinu koji nisu kasniji od ' + p['max'] + '.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Unesi mjesec i godinu koji nisu raniji od ' + p['min'] + '.',
  inputNumber_converterParseError: () => 'Unesi broj.',
  inputNumber_decrease: () => 'Smanji',
  inputNumber_increase: () => 'Povećaj',
  inputPassword_hidden: () => 'Lozinka je skrivena',
  inputPassword_hide: () => 'Sakrij lozinku',
  inputPassword_show: () => 'Prikaži lozinku',
  inputSensitiveText_hidden: () => 'Osjetljiv tekst je skriven',
  list_msgFetchCompleted: () => 'Učitano',
  list_msgFetchingData: () => 'Učitavanje',
  list_suggestion: () => 'Prijedlog',
  messageToast_allMessagesClosed: () => 'Sve toast poruke su zatvorene.',
  message_close: () => 'Zatvori',
  message_confirmation: () => 'Uspješno',
  message_error: () => 'Greška',
  message_info: () => 'Informacije',
  message_navigationFromMessagesRegion: () =>
    'Područje za unošenje poruka. Pritisnite F6 za povratak na prethodno fokusirani element.',
  message_navigationToMessagesRegion: () =>
    'Područje za poruke sadrži nove poruke. Pritisnite F6 za prelazak na područje s najnovijim porukama.',
  message_warning: () => 'Upozorenje',
  noData_message: () => 'Nema stavki za prikaz',
  overflowItemLabel: () => 'Više kartica',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'U toku',
  radio_helpForRadio: () => 'Pomoć za izborno dugme',
  radio_requiredMessageDetail: () => 'Izaberi vrijednost.',
  selectMultiple_apply: () => 'Primijeni',
  selectMultiple_back: () => 'Nazad',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Istaknite izabrane vrijednosti pomoću tipki s lijevom i desnom strelicom.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Pritisnite Backspace ili Delete da uklonite izabrane vrijednosti.',
  selectMultiple_selectedValues: () => 'Izabrane vrijednosti',
  selectMultiple_showSelectedValues: () => 'Prikaži samo izabrane vrijednosti.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Izabrano vrijednosti: ' + p['VALUE_COUNT'] + '.',
  select_addToList: () => 'Dodaj na spisak',
  select_addToListAvailable: () => 'Dostupno je dodavanje na spisak',
  select_moreSearchOptions: () => 'Više opcija pretraživanja',
  select_moreSearchOptionsAvailable: () => 'Dostupno je više opcija pretraživanja',
  select_noMatchesFound: () => 'Nije pronađeno nijedno podudaranje.',
  select_oneMatchFound: () => 'Pronađeno je jedno podudaranje',
  select_requiredMessageDetail: () => 'Izaberi vrijednost.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Pronađeno podudaranja: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Pronađeno podudaranja: najmanje ' + p['TOTAL_SIZE'],
  selectorAll_deselectAll: () => 'Poništi izbor svega',
  selectorAll_selectAll: () => 'Izaberi sve',
  selector_selected: () => 'Okvir je potvrđen',
  selector_unselected: () => 'Okvir nije potvrđen',
  tabBarNavigationList_removeCueText: () => 'Može se ukloniti',
  timeComponent_tooltipZoomIn: () => 'Uvećaj',
  timeComponent_tooltipZoomOut: () => 'Umanji',
  train_current: () => 'Trenutno',
  train_message_type: () => 'Vrsta poruke',
  train_not_visited: () => 'Nije posjećeno',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Korak ' + p['currentStep'] + ' od ' + p['numberOfSteps'],
  train_visited: () => 'Posjećeno',
  userAssistance_learnMore: () => 'Saznaj više',
  userAssistance_required: () => 'Obavezno',
  vis_clearSelection: () => 'Poništi odabir',
  vis_drillable: () => 'Raščlanjivo',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' od ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Marquee odabir',
  vis_marqueeZoomTooltip: () => 'Marquee zumiranje',
  vis_noData: () => 'Nema podataka za prikaz',
  vis_panTooltip: () => 'Pomicanje',
  vis_stateLoaded: () => 'Učitano',
  vis_stateLoading: () => 'Učitavanje',
  vis_stateSelected: () => 'Izabrano',
  vis_stateUnselected: () => 'Nije izabrano',
  warn: () => 'Upozorenje'
};
export default bundle;
